<script setup>
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useStore, useMapGetter } from 'dashboard/composables/store';

import PageLayout from 'dashboard/components-next/captain/PageLayout.vue';
import SettingsHeader from 'dashboard/components-next/captain/pageComponents/settings/SettingsHeader.vue';
import AssistantBehaviorForm from 'dashboard/components-next/captain/pageComponents/assistant/settings/AssistantBehaviorForm.vue';

const { t } = useI18n();
const route = useRoute();
const store = useStore();

const assistantId = computed(() => Number(route.params.assistantId));
const uiFlags = useMapGetter('captainAssistants/getUIFlags');
const isFetching = computed(() => uiFlags.value.fetchingItem);
const assistant = computed(() =>
  store.getters['captainAssistants/getRecord'](assistantId.value)
);

watch(
  assistantId,
  newId => {
    if (newId) store.dispatch('captainAssistants/show', newId);
  },
  { immediate: true }
);

const handleSubmit = async updatedAssistant => {
  try {
    await store.dispatch('captainAssistants/update', {
      id: assistantId.value,
      ...updatedAssistant,
    });
    useAlert(t('CAPTAIN.ASSISTANTS.EDIT.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(error?.message || t('CAPTAIN.ASSISTANTS.EDIT.ERROR_MESSAGE'));
  }
};
</script>

<template>
  <PageLayout
    :header-title="t('CAPTAIN.BEHAVIOR.HEADER')"
    :is-fetching="isFetching"
    :show-pagination-footer="false"
    :show-know-more="false"
  >
    <template #body>
      <div class="flex flex-col gap-6 pb-8">
        <SettingsHeader
          :heading="t('CAPTAIN.BEHAVIOR.TITLE')"
          :description="t('CAPTAIN.BEHAVIOR.DESCRIPTION')"
        />
        <AssistantBehaviorForm
          v-if="assistant"
          :assistant="assistant"
          @submit="handleSubmit"
        />
      </div>
    </template>
  </PageLayout>
</template>
